import jsPDF from 'jspdf';
import moment from 'moment';
import rareLogo from '../img/rareLogo';
import summaryImg from '../img/summaryImg';
import { store } from '../../store/store';
import {
  calcBarWidth,
  calculateNextLegendX,
  calculateTitleXOffset,
  formatFlagBreakdownData,
  generatePDFfileName,
  hex2rgb,
} from './js/functions';

const chartWidth = 262;

let titleY;
let chartY;
let dataX;
let dataY;
const categoryDataX = 300;
const singleMetricDataX = 310;

// Some functions we'll need in this module.
function moveYdownTitle(points = 62) {
  const newValue = chartY + points;
  titleY = newValue;
  return newValue;
}

function moveYdownChart(points = 6) {
  const newValue = titleY + points;
  chartY = newValue;
  return newValue;
}

function parseArray(array) {
  let baseLabelString;
  let compLabelString;
  let compLabelString2;
  let compLabelString3;
  let baseString;
  let compString;
  let compString2;
  let compString3;
  const percentage = (store.getters.dataFormat === 'percentage' ? '%' : '');
  const decimalPlaces = (store.getters.dataFormat === 'percentage' ? 1 : 0);

  if (typeof array[0] === 'number') {
    baseLabelString = `${array[0].toFixed(decimalPlaces).toString()}${percentage}`;
    baseString = array[0].toFixed(decimalPlaces);
  } else {
    baseLabelString = 'N/A';
    baseString = '';
  }

  if (typeof array[1] === 'number') {
    compLabelString = `${array[1].toFixed(decimalPlaces).toString()}${percentage}`;
    compString = array[1].toFixed(decimalPlaces);
  } else {
    compLabelString = 'N/A';
    compString = '';
  }

  if (typeof array[2] === 'number') {
    compLabelString2 = `${array[2].toFixed(decimalPlaces).toString()}${percentage}`;
    compString2 = array[2].toFixed(decimalPlaces);
  } else {
    compLabelString2 = 'N/A';
    compString2 = '';
  }

  if (typeof array[3] === 'number') {
    compLabelString3 = `${array[3].toFixed(decimalPlaces).toString()}${percentage}`;
    compString3 = array[3].toFixed(decimalPlaces);
  } else {
    compLabelString3 = 'N/A';
    compString3 = '';
  }

  return {
    baseLabel: baseLabelString,
    compLabel: compLabelString,
    compLabel2: compLabelString2,
    compLabel3: compLabelString3,
    base: baseString,
    comp: compString,
    comp2: compString2,
    comp3: compString3,
  };
}

export default function summaryPDFexportOneComp() {
  const { dataFormat } = store.getters;
  const flagBreakDownData = {};
  flagBreakDownData.baseDataDate = store.getters['summary/getSummaryFlagBreakDownData']({
    type: 'Base',
    dataFormat,
  });
  flagBreakDownData.comparisonDataDate = store.getters['summary/getSummaryFlagBreakDownData']({
    type: 'Comparison',
    dataFormat,
  });

  const legendDataArray = store.getters.legendData;

  const OnePlusFlagData = parseArray(store.getters['summary/getSummaryOnePlusFlagData'](dataFormat));
  const SocioeconomicFlagData = parseArray(store.getters['summary/getSummaryCategoryData']({
    type: 'Socioeconomic flags',
    dataFormat,
  }));
  const SocioeconomicFlagFirsGenUniData = parseArray(store.getters.getSummarySingleMetricData({
    type: 'First Gen',
    dataFormat,
  }));
  const SocioeconomicFlagFreeSchoolMealsData = parseArray(store.getters.getSummarySingleMetricData({
    type: 'FSM',
    dataFormat,
  }));
  const SocioeconomicFlagPostcodeData = parseArray(store.getters.getSummarySingleMetricData({
    type: 'Disadvantaged postcode',
    dataFormat,
  }));
  const SocioeconomicFlagUniWorkData = parseArray(store.getters.getSummarySingleMetricData({
    type: 'Uni Term Work',
    dataFormat,
  }));
  const SocioeconomicFlagSchoolWorkData = parseArray(store.getters.getSummarySingleMetricData({
    type: 'School Term Work',
    dataFormat,
  }));
  const AcademicFlagData = parseArray(store.getters['summary/getSummaryCategoryData']({
    type: 'Academic flags',
    dataFormat,
  }));
  const AcademicFlagBottom40Data = parseArray(store.getters.getSummarySingleMetricData({
    type: 'Bottom 40% school',
    dataFormat,
  }));
  const AcademicFlagBottom10Data = parseArray(store.getters.getSummarySingleMetricData({
    type: 'Bottom 10% school',
    dataFormat,
  }));
  const PersonalFlagData = parseArray(store.getters['summary/getSummaryCategoryData']({
    type: 'Personal flags',
    dataFormat,
  }));
  const PersonalRefugeeData = parseArray(store.getters.getSummarySingleMetricData({
    type: 'Refugee/Asylum seeker',
    dataFormat,
  }));
  const PersonalInCareData = parseArray(store.getters.getSummarySingleMetricData({
    type: 'In care',
    dataFormat,
  }));
  const PersonalCarerData = parseArray(store.getters.getSummarySingleMetricData({
    type: 'Carer/Parent',
    dataFormat,
  }));

  const filename = generatePDFfileName();
  const title = store.getters.currentClientDisplayName;

  const fromDate = moment(store.getters.fromDate, 'YYYY-MM-DD')
    .format('DD/MM/YYYY');
  const toDate = moment(store.getters.toDate, 'YYYY-MM-DD')
    .format('DD/MM/YYYY');
  const totalApplications = store.getters.totalApplicationsBase;

  const textColors = store.getters.fetchTextColors;
  const barColors = store.getters.fetchBarColors;

  const barBaseColor = hex2rgb(barColors[0]);
  const barCompColor = hex2rgb(barColors[1]);
  const barCompColor2 = hex2rgb(barColors[2]);
  const barCompColor3 = hex2rgb(barColors[3]);

  const textBaseColor = hex2rgb(textColors[0]);
  const textCompColor = hex2rgb(textColors[1]);
  const textCompColor2 = hex2rgb(textColors[2]);
  const textCompColor3 = hex2rgb(textColors[3]);

  const doc = new jsPDF(
    {
      orientation: 'p',
      unit: 'pt',
      format: 'a4',
    },
  );

  doc.setFont('helvetica');

  // Header with logo and client name
  doc.setFillColor(50, 60, 68);
  doc.rect(20, 20, 555, 50, 'F');
  doc.addImage(rareLogo, 'PNG', 30, 33, 138, 24);
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.text(title, calculateTitleXOffset(title), 50);

  // Sub-header with  divider lines and "SUMMARY" header
  doc.setDrawColor(221, 221, 221);
  doc.setLineWidth(1);
  doc.line(20, 125, 575, 125);
  doc.addImage(summaryImg, 'PNG', 22, 90, 111, 17);
  doc.line(20, 165, 575, 165);

  // Dates and total apps section to the right
  doc.setTextColor(74, 91, 104);
  doc.setFontSize(10);
  doc.text(397, 91, 'Date Range:');
  doc.text(397, 109, 'Report based on:');
  doc.setFont('helvetica', 'normal', 'bold');
  doc.text(460, 91, `${fromDate} - ${toDate}`);
  doc.text(480, 109, `${totalApplications} applications`);

  // THE LEGEND SECTION
  // Current client
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.setFillColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.circle(25, 137, 4, 'F');
  doc.text(38, 140, legendDataArray[0]);

  // First year comp
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.setFillColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.circle(calculateNextLegendX(legendDataArray[0], 25), 137, 4, 'F');
  doc.text(calculateNextLegendX(legendDataArray[0], 38), 140, legendDataArray[1]);

  // Second year comp
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.setFillColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.circle(
    calculateNextLegendX(
      legendDataArray[1],
      calculateNextLegendX(legendDataArray[0], 25),
    ),
    137,
    4,
    'F',
  );
  doc.text(
    calculateNextLegendX(
      legendDataArray[1],
      calculateNextLegendX(
        legendDataArray[0],
        38,
      ),
    ),
    140,
    legendDataArray[2],
  );

  // Current client
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor2.b);
  doc.setFillColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.circle(25, 152, 4, 'F');
  doc.text(38, 156, legendDataArray[2]);

  // Set text styles for the rest of the export
  doc.setTextColor(50, 60, 68);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'normal', 'normal');

  // Flag Breakdown column
  doc.text(350, 205, 'FLAG BREAKDOWN');
  doc.line(350, 220, 580, 220);
  doc.addImage(window.summaryFlagBreakdownChartImg, 'PNG', 350, 230, 200, 430);
  doc.line(350, 670, 580, 670);

  // Loop through and insert data for Flag Breakdown chart.
  dataX = 550;
  dataY = 223;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'bold');
  for (let i = 0; i < 6; i += 1) {
    dataY += 28.25;
    doc.setTextColor(50, 140, 161);
    doc.text(dataX, dataY, formatFlagBreakdownData(flagBreakDownData.baseDataDate[0][i]));
    dataY += 14;
    doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
    doc.text(dataX, dataY, formatFlagBreakdownData(flagBreakDownData.baseDataDate[1][i]));
    dataY += 14;
    doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
    doc.text(dataX, dataY, formatFlagBreakdownData(flagBreakDownData.baseDataDate[2][i]));
    dataY += 14;
    doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
    doc.text(dataX, dataY, formatFlagBreakdownData(flagBreakDownData.baseDataDate[3][i]));
  }

  // One plus flag chart
  doc.setTextColor(50, 60, 68);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(20, 205, '1+ FLAG APPLICATIONS');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, 220, calcBarWidth(OnePlusFlagData.base, chartWidth), 28, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, 252, calcBarWidth(OnePlusFlagData.comp, chartWidth), 28, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, 284, calcBarWidth(OnePlusFlagData.comp2, chartWidth), 28, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, 316, calcBarWidth(OnePlusFlagData.comp3, chartWidth), 28, 'F');

  // Insert data for One Plus Flag chart.
  doc.setFont('helvetica', 'normal', 'normal');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(292, 240, OnePlusFlagData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(292, 270, OnePlusFlagData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(292, 303, OnePlusFlagData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(292, 334, OnePlusFlagData.compLabel3);

  // Socioeconomic section
  doc.line(20, 360, 340, 360);

  doc.setTextColor(74, 91, 104);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(20, 390, 'SOCIOECONOMIC FLAG');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, 400, calcBarWidth(SocioeconomicFlagData.base, chartWidth), 19, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, 421, calcBarWidth(SocioeconomicFlagData.comp, chartWidth), 19, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, 442, calcBarWidth(SocioeconomicFlagData.comp2, chartWidth), 19, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, 463, calcBarWidth(SocioeconomicFlagData.comp3, chartWidth), 19, 'F');

  // Insert data forSocioeconomic Flag chart.
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(categoryDataX, 415, SocioeconomicFlagData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(categoryDataX, 436, SocioeconomicFlagData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(categoryDataX, 457, SocioeconomicFlagData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(categoryDataX, 478, SocioeconomicFlagData.compLabel3);

  doc.setTextColor(50, 60, 68);
  doc.setFontSize(10);

  titleY = 510;
  chartY = 518;

  // Socioeconomic Flag -  FirsT Gen Uni Data
  doc.setTextColor(74, 91, 104);
  doc.setFont('helvetica', 'normal', 'bold');
  doc.text(20, titleY, 'First Generation at University');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, chartY, calcBarWidth(SocioeconomicFlagFirsGenUniData.base, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, chartY + 11, calcBarWidth(SocioeconomicFlagFirsGenUniData.comp, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, chartY + 22, calcBarWidth(SocioeconomicFlagFirsGenUniData.comp2, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, chartY + 33, calcBarWidth(SocioeconomicFlagFirsGenUniData.comp3, chartWidth), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, SocioeconomicFlagFirsGenUniData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(singleMetricDataX, chartY + 19, SocioeconomicFlagFirsGenUniData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(singleMetricDataX, chartY + 30, SocioeconomicFlagFirsGenUniData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(singleMetricDataX, chartY + 41, SocioeconomicFlagFirsGenUniData.compLabel3);

  // Socioeconomic Flag - Free School Meals Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'Free School Meals');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(SocioeconomicFlagFreeSchoolMealsData.base, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, moveYdownChart() + 11, calcBarWidth(SocioeconomicFlagFreeSchoolMealsData.comp, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, moveYdownChart() + 22, calcBarWidth(SocioeconomicFlagFreeSchoolMealsData.comp2, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, moveYdownChart() + 33, calcBarWidth(SocioeconomicFlagFreeSchoolMealsData.comp3, chartWidth), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, SocioeconomicFlagFreeSchoolMealsData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(singleMetricDataX, chartY + 19, SocioeconomicFlagFreeSchoolMealsData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(singleMetricDataX, chartY + 30, SocioeconomicFlagFreeSchoolMealsData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(singleMetricDataX, chartY + 41, SocioeconomicFlagFreeSchoolMealsData.compLabel3);

  // Socioeconomic Flag - Postcode Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'Disadvantaged Postcode');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(SocioeconomicFlagPostcodeData.base, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, moveYdownChart() + 11, calcBarWidth(SocioeconomicFlagPostcodeData.comp, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, moveYdownChart() + 22, calcBarWidth(SocioeconomicFlagPostcodeData.comp2, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, moveYdownChart() + 33, calcBarWidth(SocioeconomicFlagPostcodeData.comp3, chartWidth), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, SocioeconomicFlagPostcodeData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(singleMetricDataX, chartY + 19, SocioeconomicFlagPostcodeData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(singleMetricDataX, chartY + 30, SocioeconomicFlagPostcodeData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(singleMetricDataX, chartY + 41, SocioeconomicFlagPostcodeData.compLabel3);

  // Socioeconomic Flag - Uni Work Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'University Term Work');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(SocioeconomicFlagUniWorkData.base, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, moveYdownChart() + 11, calcBarWidth(SocioeconomicFlagUniWorkData.comp, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, moveYdownChart() + 22, calcBarWidth(SocioeconomicFlagUniWorkData.comp2, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, moveYdownChart() + 33, calcBarWidth(SocioeconomicFlagUniWorkData.comp3, chartWidth), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, SocioeconomicFlagUniWorkData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(singleMetricDataX, chartY + 19, SocioeconomicFlagUniWorkData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(singleMetricDataX, chartY + 30, SocioeconomicFlagUniWorkData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(singleMetricDataX, chartY + 41, SocioeconomicFlagUniWorkData.compLabel3);

  // Socioeconomic Flag - School Work Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'School Term Work');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(SocioeconomicFlagSchoolWorkData.base, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, moveYdownChart() + 11, calcBarWidth(SocioeconomicFlagSchoolWorkData.comp, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, moveYdownChart() + 22, calcBarWidth(SocioeconomicFlagSchoolWorkData.comp2, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, moveYdownChart() + 33, calcBarWidth(SocioeconomicFlagSchoolWorkData.comp3, chartWidth), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, SocioeconomicFlagSchoolWorkData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(singleMetricDataX, chartY + 19, SocioeconomicFlagSchoolWorkData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(singleMetricDataX, chartY + 30, SocioeconomicFlagSchoolWorkData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(singleMetricDataX, chartY + 41, SocioeconomicFlagSchoolWorkData.compLabel3);

  // Page x of y at the bottom of the page
  doc.setTextColor(74, 91, 104);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(515, 820, 'Page 1 of 2');

  // ******************** START OF SECOND PAGE *******************
  doc.addPage();
  // Header with logo and client name
  doc.setFillColor(50, 60, 68);
  doc.rect(20, 20, 555, 50, 'F');
  doc.addImage(rareLogo, 'PNG', 30, 33, 138, 24);
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.text(title, calculateTitleXOffset(title), 50);

  // Sub-header with  divider lines and "SUMMARY" header
  doc.setDrawColor(221, 221, 221);
  doc.setLineWidth(1);
  doc.line(20, 125, 575, 125);
  doc.addImage(summaryImg, 'PNG', 22, 90, 111, 17);
  doc.line(20, 165, 575, 165);

  // Dates and total apps section to the right
  doc.setTextColor(74, 91, 104);
  doc.setFontSize(10);
  doc.text(397, 91, 'Date Range:');
  doc.text(397, 109, 'Report based on:');
  doc.setFont('helvetica', 'normal', 'bold');
  doc.text(460, 91, `${fromDate} - ${toDate}`);
  doc.text(480, 109, `${totalApplications} applications`);

  // THE LEGEND SECTION
  // Current client
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.setFillColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.circle(25, 137, 4, 'F');
  doc.text(38, 140, legendDataArray[0]);

  // First year comp
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.setFillColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.circle(calculateNextLegendX(legendDataArray[0], 25), 137, 4, 'F');
  doc.text(calculateNextLegendX(legendDataArray[0], 38), 140, legendDataArray[1]);

  // Second year comp
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.setFillColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.circle(calculateNextLegendX(legendDataArray[1], calculateNextLegendX(legendDataArray[0], 25)), 137, 4, 'F');
  doc.text(
    calculateNextLegendX(
      legendDataArray[1],
      calculateNextLegendX(
        legendDataArray[0],
        38,
      ),
    ),
    140,
    legendDataArray[2],
  );

  // Current client
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor2.b);
  doc.setFillColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.circle(25, 152, 4, 'F');
  doc.text(38, 156, legendDataArray[2]);

  // Set text styles for the rest of the export
  doc.setTextColor(50, 60, 68);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'normal', 'normal');

  // ACADEMIC SECTION
  doc.setTextColor(74, 91, 104);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(20, 210, 'ACADEMIC FLAG');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, 220, calcBarWidth(AcademicFlagData.base, chartWidth), 19, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, 241, calcBarWidth(AcademicFlagData.comp, chartWidth), 19, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, 262, calcBarWidth(AcademicFlagData.comp2, chartWidth), 19, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, 283, calcBarWidth(AcademicFlagData.comp3, chartWidth), 19, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(categoryDataX, 235, AcademicFlagData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(categoryDataX, 256, AcademicFlagData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(categoryDataX, 277, AcademicFlagData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(categoryDataX, 298, AcademicFlagData.compLabel3);

  doc.setTextColor(50, 60, 68);
  doc.setFontSize(10);

  titleY = 327;
  chartY = 335;

  doc.setTextColor(74, 91, 104);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'bold');

  // Academic Flag - Bottom 40%
  doc.text(20, titleY, 'Bottom 40% school');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(AcademicFlagBottom40Data.base, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, moveYdownChart() + 11, calcBarWidth(AcademicFlagBottom40Data.comp), 10, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, moveYdownChart() + 22, calcBarWidth(AcademicFlagBottom40Data.comp2), 10, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, moveYdownChart() + 33, calcBarWidth(AcademicFlagBottom40Data.comp3), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, AcademicFlagBottom40Data.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(singleMetricDataX, chartY + 19, AcademicFlagBottom40Data.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(singleMetricDataX, chartY + 30, AcademicFlagBottom40Data.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(singleMetricDataX, chartY + 41, AcademicFlagBottom40Data.compLabel3);

  // Academic Flag - Bottom 10%
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'Bottom 10% school');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(AcademicFlagBottom10Data.base, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, moveYdownChart() + 11, calcBarWidth(AcademicFlagBottom10Data.comp, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, moveYdownChart() + 22, calcBarWidth(AcademicFlagBottom10Data.comp2), 10, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, moveYdownChart() + 33, calcBarWidth(AcademicFlagBottom10Data.comp3, chartWidth), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, AcademicFlagBottom10Data.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(singleMetricDataX, chartY + 19, AcademicFlagBottom10Data.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(singleMetricDataX, chartY + 30, AcademicFlagBottom10Data.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(singleMetricDataX, chartY + 41, AcademicFlagBottom10Data.compLabel3);

  doc.line(20, 460, 340, 460);
  doc.setTextColor(74, 91, 104);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal', 'normal');
  doc.text(20, 490, 'PERSONAL FLAG');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, 500, calcBarWidth(PersonalFlagData.base, chartWidth), 19, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, 521, calcBarWidth(PersonalFlagData.comp, chartWidth), 19, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, 542, calcBarWidth(PersonalFlagData.comp2, chartWidth), 19, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, 564, calcBarWidth(PersonalFlagData.comp3, chartWidth), 19, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(categoryDataX, 515, PersonalFlagData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(categoryDataX, 536, PersonalFlagData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(categoryDataX, 557, PersonalFlagData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(categoryDataX, 578, PersonalFlagData.compLabel3);

  doc.setTextColor(50, 60, 68);
  doc.setFontSize(10);

  titleY = 608;
  chartY = 616;

  doc.setTextColor(74, 91, 104);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'bold');

  // Personal Flag -  Refugee Data
  doc.text(20, titleY, 'Refugee/Asylum seeker');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, chartY, calcBarWidth(PersonalRefugeeData.base, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, chartY + 11, calcBarWidth(PersonalRefugeeData.comp, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, chartY + 22, calcBarWidth(PersonalRefugeeData.comp2, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, chartY + 33, calcBarWidth(PersonalRefugeeData.comp3, chartWidth), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, PersonalRefugeeData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(singleMetricDataX, chartY + 19, PersonalRefugeeData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(singleMetricDataX, chartY + 30, PersonalRefugeeData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(singleMetricDataX, chartY + 41, PersonalRefugeeData.compLabel3);

  // Personal Flag - In Care Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'In care');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(PersonalInCareData.base, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, moveYdownChart() + 11, calcBarWidth(PersonalInCareData.comp, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, moveYdownChart() + 22, calcBarWidth(PersonalInCareData.comp2, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, moveYdownChart() + 33, calcBarWidth(PersonalInCareData.comp3, chartWidth), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, PersonalInCareData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(singleMetricDataX, chartY + 19, PersonalInCareData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(singleMetricDataX, chartY + 30, PersonalInCareData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(singleMetricDataX, chartY + 41, PersonalInCareData.compLabel3);

  // Personal Flag - Parent/Carer Data
  doc.setTextColor(74, 91, 104);
  doc.text(20, moveYdownTitle(), 'Carer/Parent');
  doc.setFillColor(barBaseColor.r, barBaseColor.g, barBaseColor.b);
  doc.rect(20, moveYdownChart(), calcBarWidth(PersonalCarerData.base, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor.r, barCompColor.g, barCompColor.b);
  doc.rect(20, moveYdownChart() + 11, calcBarWidth(PersonalCarerData.comp, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor2.r, barCompColor2.g, barCompColor2.b);
  doc.rect(20, moveYdownChart() + 22, calcBarWidth(PersonalCarerData.comp2, chartWidth), 10, 'F');
  doc.setFillColor(barCompColor3.r, barCompColor3.g, barCompColor3.b);
  doc.rect(20, moveYdownChart() + 33, calcBarWidth(PersonalCarerData.comp3, chartWidth), 10, 'F');
  doc.setTextColor(textBaseColor.r, textBaseColor.g, textBaseColor.b);
  doc.text(singleMetricDataX, chartY + 9, PersonalCarerData.baseLabel);
  doc.setTextColor(textCompColor.r, textCompColor.g, textCompColor.b);
  doc.text(singleMetricDataX, chartY + 19, PersonalCarerData.compLabel);
  doc.setTextColor(textCompColor2.r, textCompColor2.g, textCompColor2.b);
  doc.text(singleMetricDataX, chartY + 30, PersonalCarerData.compLabel2);
  doc.setTextColor(textCompColor3.r, textCompColor3.g, textCompColor3.b);
  doc.text(singleMetricDataX, chartY + 41, PersonalCarerData.compLabel3);

  // Page x of y at the bottom of the page
  doc.setTextColor(74, 91, 104);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal', 'bold');
  doc.text(515, 820, 'Page 2 of 2');

  // Fianlly, save the file.
  doc.save(filename);
}
